import React, {useContext} from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import AuditTab from '../AuditTab'
import {AuditContext} from '../../context/Audits'
import {TemplatesContext} from '../../context/Templates'
import AuditTemplateTab from '../AuditTemplateTab'
import {AuditPaneContext} from '../../context/AuditPane'
import {UserContext} from '../../context/User'
import Spinner from 'react-bootstrap/Spinner'
import AuditError from '../AuditError'

function AuditPane({id}) {
  const {audits, selectAudit, getsAudit} = React.useContext(AuditContext)
  const {templates, selectTemplate} = React.useContext(TemplatesContext)
  const paneState = useContext(AuditPaneContext)
  const [loader, setLoader] = React.useState(false)
  const [tabWidth, setTabWidth] = React.useState(1654)
  const [showErrorPage, setShowErrorPage] = React.useState(false)
  const user = useContext(UserContext)
  const {t} = useTranslation()
  const permission = (user && user.details && user.details.allow_to_create_audit) || false
  const tabElement = React.useRef(null)

  const handleSelect = selectedTab => {
    if (selectedTab === 'audit') {
      if (audits && audits.audits && audits.audits.length > 0) {
        selectAudit(audits.audits[0])
        paneState.setActiveTab(selectedTab, paneState.isSidebarOpen, paneState.isExpandOpen)
      } else {
        paneState.setActiveTab(selectedTab, false, false)
      }
    } else {
      if (templates && templates.audits && templates.audits.length > 0) {
        selectTemplate(templates.audits[0])
        paneState.setActiveTab(selectedTab, paneState.isSidebarOpen, paneState.isExpandOpen)
      } else {
        paneState.setActiveTab(selectedTab, false, false)
      }
    }
  }

  React.useEffect(() => {
    if (tabElement !== undefined && tabElement.current.offsetWidth !== undefined) {
      setTabWidth(tabElement.current.offsetWidth)
    }
    if (id && !paneState.isExpandOpen) {
      setLoader(true)
      getsAudit(id).then(res => {
        if (res) {
          selectAudit(res)
          paneState.openExpand()
          setLoader(false)
        } else {
          setShowErrorPage(true)
        }
      })
    }
  }, [getsAudit, paneState.isExpandOpen, paneState.openExpand, selectAudit, id, paneState])

  return (
    <div ref={tabElement} className="audit-pane">
      {!loader && !showErrorPage ? (
        <div>
          {user && !user.isLoading ? (
            permission ? (
              <>
                {!paneState.isExpandOpen && (
                  <button
                    className="audit-button audit-button--outline audit-button--blue-4 float_right"
                    onClick={() => {
                      paneState.openModal()
                    }}
                  >
                    {t('audit.button.create')}
                  </button>
                )}
                <Tabs
                  activeKey={paneState.activeTab}
                  onSelect={handleSelect}
                  className={
                    'audit-pane__tabs' +
                    `${paneState.isExpandOpen ? ' audit-pane__tabs--small' : ''}`
                  }
                >
                  <Tab eventKey={'audit'} title={t('audit.pane.tab-1')} className="audit-pane__tab">
                    <AuditTab tabWidth={tabWidth} />
                  </Tab>
                  <Tab
                    eventKey={'auditTemplate'}
                    title={t('audit.pane.tab-2')}
                    className="audit-pane__tab"
                  >
                    <AuditTemplateTab tabWidth={tabWidth} />
                  </Tab>
                </Tabs>
              </>
            ) : (
              <div
                className={
                  permission
                    ? 'tab-content border_radius'
                    : 'tab-content border_radius height-100-percent'
                }
              >
                <AuditTab tabWidth={tabWidth} />
              </div>
            )
          ) : (
            <div className="spinner5">
              <Spinner className="spinner" animation="border" role="status" />
              <br></br>
              <h5>{t('commons.loading')}</h5>
            </div>
          )}
        </div>
      ) : (
        <>
          {!showErrorPage ? (
            <div className="spinner5">
              <Spinner className="spinner" animation="border" role="status" />
              <br></br>
              <h5>Loading...Please wait</h5>
            </div>
          ) : (
            <AuditError />
          )}
        </>
      )}
    </div>
  )
}

export default AuditPane
